import { useEffect } from "react";
import { loadTipsForMonth } from "../logic/tips.v2.logic";
import type { UseTipLoaderProps } from "../tips.component.types";

export const useTipLoader = (props: UseTipLoaderProps): void => {
  const companyId = props.companyId;
  const currentDate = props.currentDate;
  const setErrorMessage = props.setErrorMessage;
  const setIsLoadingTips = props.setIsLoadingTips;
  const setTips = props.setTips;
  const t = props.t;

  useEffect(() => {
    if (companyId === null) {
      setErrorMessage(null);
      setIsLoadingTips(false);
      setTips([]);
      return;
    }

    let isActive = true;

    const loadTips = async (): Promise<void> => {
      setIsLoadingTips(true);
      setErrorMessage(null);

      try {
        const result = await loadTipsForMonth({
          companyId,
          monthDate: currentDate,
        });
        if (!isActive) return;

        if (result.ok) {
          setTips(result.value);
        } else {
          setErrorMessage(t("Tips.UnexpectedError"));
        }
      } catch (_error: unknown) {
        if (isActive) {
          setErrorMessage(t("Tips.UnexpectedError"));
        }
      } finally {
        if (isActive) {
          setIsLoadingTips(false);
        }
      }
    };

    void loadTips();

    return () => {
      isActive = false;
    };
  }, [companyId, currentDate, setErrorMessage, setIsLoadingTips, setTips, t]);
};
